import { ajax } from "@utils";

export const householdService = {
  /**
   * 取得建案住戶列表
   * @key SearchHouseholdByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/households`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得建物住戶資訊
   * @key GetHouseholdByProperty
   * @param {number} id - 戶別 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/households/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 更新戶別資訊
   * @key UpdateHouseholdByProperty
   * @param {number} id - 戶別 id
   * @param {object} info - 戶別資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/households/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 戶別綁定使用者
   * @key CreateHouseholdUserByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {string} userUuid - 使用者 uuid
   * @param {object} info - 加入戶別的資訊
   *
   * @returns
   */
  joinHouseholdByUser: (constructionUuid, userUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/users/${userUuid}`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 戶別綁定門禁卡
   * @key CreateHouseholdAccessCardByProperty
   * @param {string} cardId - 門禁卡 id
   * @param {object} info - 加入戶別的資訊
   *
   * @returns
   */
  joinHouseholdByCard: (householdId, cardId) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/households/${householdId}/access-cards/${cardId}`,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 住戶參數設定
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 設定資訊
   * @returns
   */
  settingHouseholdUserConfig: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages/protected-setting`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  }
};
